// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.back {
  position: fixed;
  top: 20px;
  left: 20px;
  color: var(--text-primary);
  width: 48px;
  height: 48px;
  font-size: 20px;
  padding: 0;
  border: 2px solid var(--border-secondary);
  background: var(--bg-overlay);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  transition: all 0.3s ease;
  z-index: 1000;
  cursor: pointer;
}

.back:hover {
  border-color: var(--border-hover);
  background: var(--bg-secondary);
  transform: translateX(-2px);
}

.back:active {
  transform: translateX(0);
}

@media (max-width: 480px) {
  .back {
    top: max(12px, env(safe-area-inset-top));
    left: max(12px, env(safe-area-inset-left));
  }
}
`, "",{"version":3,"sources":["webpack://./src/LandingPage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,yCAAyC;EACzC,6BAA6B;EAC7B,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,wCAAwC;IACxC,0CAA0C;EAC5C;AACF","sourcesContent":[".back {\n  position: fixed;\n  top: 20px;\n  left: 20px;\n  color: var(--text-primary);\n  width: 48px;\n  height: 48px;\n  font-size: 20px;\n  padding: 0;\n  border: 2px solid var(--border-secondary);\n  background: var(--bg-overlay);\n  backdrop-filter: blur(10px);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  z-index: 1000;\n  cursor: pointer;\n}\n\n.back:hover {\n  border-color: var(--border-hover);\n  background: var(--bg-secondary);\n  transform: translateX(-2px);\n}\n\n.back:active {\n  transform: translateX(0);\n}\n\n@media (max-width: 480px) {\n  .back {\n    top: max(12px, env(safe-area-inset-top));\n    left: max(12px, env(safe-area-inset-left));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
